import * as THREE from 'three';
import {
  CARD1Web
} from '../CoordUtils.js';

import {
  BaseDrawer
} from "@/drawings3D/modelDrawing/BaseDrawer"
import {
  LaneDividerLine
} from '@/drawings3D/models/LaneDividerLine'
export class LaneDividerLineDrawer extends BaseDrawer {
  constructor(laneDividerLine, sceneManager, medialDividerWidth, stepFactor) {
    super(sceneManager, laneDividerLine.startStake, laneDividerLine.endStake, laneDividerLine.roadStakes);
    this.dividerLineMaterial = new THREE.MeshBasicMaterial({
      color: 0xffffff
    });
    this.laneDividerLine = laneDividerLine;
    this.laneNo = this.laneDividerLine.laneNo;
    this.medialDividerWidth = medialDividerWidth;
    this.totalLanes = this.laneDividerLine.totalLanes;
    this.stepFactor = stepFactor;
  }

  draw() {
    
    if (this.laneDividerLine.laneNo < 0) {
        //在起点构建shape
      var pts = [];
      pts.push(new THREE.Vector2(-0.01, 0));
      pts.push(new THREE.Vector2(-0.01, this.laneDividerLine.lineWidth));
      var curveLine = new Array();
      if (this.laneDividerLine.laneNo == -2) {
        //左道紧急停车带线
        var lerpAlpha = this.laneDividerLine.EmeZoneWidth / this.roadWidth;
        var pathPts = this.getDrawingPoints(lerpAlpha, this.laneDividerLine.laneNo);
        curveLine = pathPts;
      } else if   (this.laneDividerLine.laneNo == -1) {
        var lerpAlpha = (this.roadWidth - this.laneDividerLine.EmeZoneWidth) / this.roadWidth;
        var pathPts = this.getDrawingPoints(lerpAlpha, this.laneDividerLine.laneNo);
        curveLine = pathPts;
      }
      return this.drawExtrudeShape(curveLine, pts, this.dividerLineMaterial);
    } else {
      //中间车道和最右侧车道不需要画分隔线
      if (this.laneNo == this.totalLanes - 1 || this.laneNo == this.totalLanes / 2 - 1) return;
      var leftDist = this.laneDividerLine.EmeZoneWidth + (this.laneNo + 1) * this.laneDividerLine.LaneWidth +
        ((this.laneNo < this.totalLanes / 2) ? 0 : this.medialDividerWidth);
      var lerpAlphaLeft = (leftDist - this.laneDividerLine.lineWidth / 2) / this.roadWidth;
      var lerpAlphaRight = (leftDist + this.laneDividerLine.lineWidth / 2) / this.roadWidth;
     
      var pathPtsLeft = this.getDrawingPoints(lerpAlphaLeft, this.laneDividerLine.laneNo, 10); //需要虚线，因此要插值
      var pathPtsRight = this.getDrawingPoints(lerpAlphaRight, this.laneDividerLine.laneNo, 10);
      
      var vertices = [];
      var faces = [];
      for (var i = 0; i < pathPtsLeft.length;i++){
        pathPtsLeft[i].y +=0.01;
        vertices.push(pathPtsLeft[i]);
        pathPtsRight[i].y +=0.01;
        vertices.push(pathPtsRight[i]);
      }

      var interval = 60 / this.stakeInterval;
      for (var i = 0; i < vertices.length - 3; i = i+2){
        if (i % interval == 0) {
          i = i+2;
          continue;
        }
        faces.push(new THREE.Face3(i, i+1, i+2));
        faces.push(new THREE.Face3(i+2, i+1, i+3));
      }
      var lineGeom = new THREE.Geometry();
      lineGeom.vertices = vertices;
      lineGeom.faces = faces;
      lineGeom.computeFaceNormals();
      var lineMesh = new THREE.Mesh(lineGeom, this.dividerLineMaterial);
      this.geometry.merge(lineMesh.geometry, lineMesh.matrix);
      return new THREE.Mesh(this.geometry, this.dividerLineMaterial);     
    }
  }

}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/modelDrawing/LaneDividerLineDrawer.js